module.exports = __webpack_public_path__ + "img/lisa-maria-kompein.44859d18.jpg";